import {notification} from "../helpers/notification";
import {validation} from "../helpers/validation";
import {clearValidation} from "../helpers/clearValidation";
import {clearForm} from "../helpers/clearForm";

$(document).ready(function () {
    //Showing/hiding additional data on the modal form when choosing option type other
    $('.js-check-query-type').on('click', function () {
        const additionalData = $('.js-additional-query-data');
        const queryDescription = $('.js-query-description');
        if ($(this).is(':checked')) {
            if (Number($(this).val()) === 2) {
                if (!additionalData.is(':visible')) {
                    additionalData.slideDown();
                    queryDescription.prop('disabled', false);
                }
            }else {
                if (additionalData.is(':visible')) {
                    additionalData.slideUp();
                    queryDescription.prop('disabled', true);
                }
            }
        }
    });
    //Creating new query by ajax
    $(function () {
        const modal = $('#create-query-modal');
        const form = $('.js-create-query-form');
        $('.js-create-query-btn').on('click', function () {
            clearValidation(form[0]);
            $('body').addClass('no-loader');
            $.ajax({
                type: form.attr('method'),
                url: form.attr('action'),
                data: form.serialize(),
                success: function(response) {
                    modal.modal('hide');
                    notification(response.type, response.message);
                },
                error: function(xhr) {
                    let response = JSON.parse(xhr.responseText);
                    validation(form[0], response.errors, true);
                    notification(response.type, response.message);
                }
            })
        });
        modal.on("hidden.bs.modal", function () {
            clearValidation(form[0]);
            clearForm(form[0]);
        });
    });

});
